import { Equipment, GymTypes, WorkoutSettingsBase } from 'fitbeat.models';
import { AreaCategory } from '../../config/zone-mappings';
import { BigBodyGroup, Exercise } from '../exercise/exercise';

export class WorkoutSettings extends WorkoutSettingsBase {
  public static permanentlyRemoveFromProgram(workoutSettings: WorkoutSettings) {
    workoutSettings.ignoreProgramRecommendations = true;
  }

  public static removeEquipmentFromStudioSettings(workoutSettings: WorkoutSettings, gymType: GymTypes) {
    if (gymType !== GymTypes.Home) {
      workoutSettings.equipment = [];
    }
  }

  public static applyProgramRecommendations(current: WorkoutSettings, recommended: WorkoutSettings) {
    current.cardioOrResistance = recommended.cardioOrResistance;
    current.threeBodyGroups = recommended.threeBodyGroups;
    current.level = recommended.level;
    current.equipment = recommended.equipment;
  }

  public static hasEquipment(settings: WorkoutSettings): boolean {
    if (settings.equipment && settings.equipment.length === 0) {
      return false;
    }

    const { equipment = [] } = settings;
    const hasOnlyBodyWeight = equipment.length === 1 && equipment.indexOf(Equipment.Bodyweight) >= 0;
    if (hasOnlyBodyWeight) {
      return false;
    }

    return true;
  }

  public static isBodyGroupsCustomizationDisabled(settings: WorkoutSettings, gymType: GymTypes): boolean {
    if (settings.forceSettingsDueToAreaCategory && !WorkoutSettings.hasEquipment(settings)) {
      return true;
    }

    return ((!WorkoutSettings.hasEquipment(settings)) && gymType === GymTypes.Home)
      || gymType === GymTypes.Outdoor;
  }

  public static getFullBody(): string[] {
    return [
      BigBodyGroup.BackAndArms,
      BigBodyGroup.Lower,
      BigBodyGroup.Upper,
    ];
  }

  public static equals(a: WorkoutSettings, b: WorkoutSettings) {
    return (
      Exercise.compare3BodyGroup(a.threeBodyGroups, b.threeBodyGroups)
      && a.cardioOrResistance === b.cardioOrResistance
      && a.level === b.level
    );
  }

  public constructor(init?: Partial<WorkoutSettings>) {
    super();
    Object.assign(this, init);
  }
}

export interface IUserRecommendedSettings {
  settings: WorkoutSettings;
  calisthenic: WorkoutSettings;
}

export function selectRecommendedSettingsBasedOnArea(
  recommended: IUserRecommendedSettings,
  areaCategory: AreaCategory | 'home' | undefined,
): WorkoutSettings {
  if (areaCategory === 'calisthenic') {
    return recommended.calisthenic;
  }

  if (areaCategory === 'home') {
    return recommended.settings;
  }

  return recommended.settings;
}
